<template>
  <v-image
    ref="canvasImage"
    :config="configImg"
    :width="imageDimensions.width"
    :height="imageDimensions.height"
  />
</template>

<script setup>
import {
  computed,
} from "vue";

const props = defineProps({
  pcdProjection: {
    // three.js Points with buffer geometry
    type: HTMLImageElement,
    default: null,
  },
  imageDimensions: {
    type: Object,
    default: null,
  },
  cameraIntrinsic: {
    type: Array,
    default: null,
  },
});

const configImg = computed(() => ({
  fill: 'transparent',
  x: 0,
  y: 0,
  image: props.pcdProjection,
  width: props.imageDimensions.width,
  height: props.imageDimensions.height,
  draggable: false,
}));
</script>
